import React from 'react';
import Styles from './HyundaiTucson.module.css';
import Carousel from '../../../../components/Carousel/Carousel';
import { cars } from './Data';
import Hero from '../HeroForm/Hero';

const HyundaiTucson = () => {
  return (


    <div className={Styles.main_page}>
      <h2>Hyundai Tucson </h2>
      {/*Carousel*/}
      <div className={Styles.car_image}>
        <Carousel images={cars} />
      </div>


      <Hero selectedCar="Hyundai Tucson" />

    </div>

  );
}

export default HyundaiTucson;
